.container {
    display: flex;
    flex-direction: column;
    width: 100%;
}